import { useEffect, useRef, useState } from "react";
import Markdown from "react-markdown";
import remarkGfm from "remark-gfm";
import "./ConsultaDocumentos.css";

const documentos = [
  { id: "faq", titulo: "Perguntas frequentes", arquivo: "/documentos/faq-relatorio-viagens.md" },
  { id: "resolucao", titulo: "Resolução 012/2024", arquivo: "/documentos/resolucao-012-2024-retificada.md" },
];

export default function ConsultaDocumentos() {
  const dialogo = useRef(null);
  const leitura = useRef(null);
  const [aberto, setAberto] = useState(false);
  const [ativo, setAtivo] = useState("faq");
  const [conteudos, setConteudos] = useState({});
  const [erro, setErro] = useState("");
  const [tentativa, setTentativa] = useState(0);
  const documento = documentos.find(item => item.id === ativo);
  const conteudo = conteudos[ativo];

  useEffect(() => {
    if (!aberto) return;
    const modal = dialogo.current;
    const anterior = document.body.style.overflow;
    modal.showModal();
    document.body.style.overflow = "hidden";
    return () => {
      modal.close();
      document.body.style.overflow = anterior;
    };
  }, [aberto]);

  useEffect(() => {
    if (!aberto || conteudo !== undefined) return;
    const controller = new AbortController();
    setErro("");
    fetch(documento.arquivo, { signal: controller.signal })
      .then(resposta => {
        if (!resposta.ok || resposta.headers.get("content-type")?.includes("text/html")) {
          throw new Error("Documento indisponível");
        }
        return resposta.text();
      })
      .then(texto => setConteudos(anteriores => ({ ...anteriores, [ativo]: texto })))
      .catch(error => {
        if (error.name !== "AbortError") setErro("Não foi possível carregar o documento. Tente novamente.");
      });
    return () => controller.abort();
  }, [aberto, ativo, conteudo, documento.arquivo, tentativa]);

  function selecionar(id) {
    setErro("");
    setAtivo(id);
    if (leitura.current) leitura.current.scrollTop = 0;
  }

  return <div className="consulta-acesso">
    <button type="button" className="consulta-botao" onClick={() => setAberto(true)}>
      Normas e dúvidas
    </button>
    <dialog ref={dialogo} className="consulta-dialogo" aria-labelledby="consulta-titulo"
      onCancel={() => setAberto(false)} onClose={() => setAberto(false)}>
      <header className="consulta-cabecalho">
        <h2 id="consulta-titulo">Normas e dúvidas</h2>
        <button type="button" className="consulta-fechar" onClick={() => setAberto(false)} autoFocus>Fechar</button>
      </header>
      <nav className="consulta-seletor" aria-label="Documentos para consulta">
        {documentos.map(item => <button key={item.id} type="button" aria-pressed={ativo === item.id}
          onClick={() => selecionar(item.id)}>{item.titulo}</button>)}
      </nav>
      <div className="consulta-fonte">
        <span>Conteúdo dos documentos fornecidos para consulta.</span>
        <a href={documento.arquivo} download>Baixar original (.md)</a>
      </div>
      <article ref={leitura} className="consulta-leitura" aria-label={documento.titulo} tabIndex={0}>
        {erro ? <div role="alert"><p>{erro}</p><button type="button" onClick={() => setTentativa(valor => valor + 1)}>Tentar novamente</button></div>
          : conteudo === undefined ? <p role="status">Carregando documento...</p>
          : <Markdown remarkPlugins={[remarkGfm]} skipHtml components={{
              table: ({ node, ...props }) => <div className="consulta-tabela" tabIndex={0} role="region" aria-label="Tabela do documento"><table {...props}/></div>,
              a: ({ node, children, ...props }) => <a {...props} target="_blank" rel="noopener noreferrer">{children}</a>,
            }}>{conteudo}</Markdown>}
      </article>
    </dialog>
  </div>;
}
